import { ProductCategory } from "@medusajs/medusa"

function validateFraction(value: number | undefined, denominator?: number) {
  if (denominator === undefined) {
    return true // No fraction denominator provided, no validation required
  }
  if (value === undefined) {
    return true // Value is empty, no validation required
  }
  const fractionValue = value - Math.floor(value)
  const fractionNumerator = Math.round(fractionValue * denominator)
  return fractionNumerator === fractionValue * denominator
}

function sortProductCategories(categories: ProductCategory[], parentId: string | null = null): ProductCategory[] {
  // 1. Find categories that belong to the current parentId.
  const currentLevelCategories = categories.filter(cat => cat.parent_category_id === parentId);

  // 2. Sort these categories based on their rank.
  currentLevelCategories.sort((a, b) => a.rank - b.rank);

  let sortedCategories: ProductCategory[] = [];
  for (const category of currentLevelCategories) {
    // Push the current category to the result.
    sortedCategories.push(category);

    // Recursively sort its children.
    const children = sortProductCategories(categories, category.id);
    sortedCategories = sortedCategories.concat(children);
  }

  return sortedCategories;
}


export { sortProductCategories, validateFraction }